import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AppSplash from "@/components/mobile/AppSplash";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    // Same splash as public/index.html: no white flash between the HTML shell and the page.
    return <AppSplash testId="auth-loading" />;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
